import { isNullOrUndefined } from '@uzurv/core';
import { autoserializeAs, inheritSerialization } from 'cerialize';
import { Journey } from './journey';
import { RideInfo } from './ride-info';

@inheritSerialization(Journey)
export class JourneyDetail extends Journey {
  @autoserializeAs(RideInfo)
  rideInfos: Array<RideInfo>;

  get favoriteDriver(): boolean {
    if (isNullOrUndefined(this.rideInfos)) {
      return false;
    }

    return this.rideInfos.some(rideInfo => rideInfo.favoriteDriver);
  }
}
